export default "__VITE_ASSET__BbdRs2Uu__"